import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginUserComponent } from './account/login-user/login-user.component';
import { AdministradorComponent } from './ui-portal/administrador/administrador.component';
import { ChatSignalRComponent } from './ui-portal/chat-signal-r/chat-signal-r.component';
import { ClientComponent } from './ui-portal/client/client.component';
import { ContainersComponent } from './ui-portal/containers/containers.component';
import { CustomersComponent } from './ui-portal/customers/customers.component';
import { HomeComponent } from './ui-portal/home/home.component';
import { ProductsComponent } from './ui-portal/products/products.component';
import { ReceiveComponent } from './ui-portal/receive/receive.component';
import { ReportsComponent } from './ui-portal/reports/reports.component';
import { ShippingComponent } from './ui-portal/shipping/shipping.component';
import { ShiptordersComponent } from './ui-portal/shiptorders/shiptorders.component';
import { AppareanceComponent } from './ui-portal/appareance/appareance.component';
import { AuthGuard } from './_guards';
import { Role } from './_models';
import { ChatPortalComponent } from './ui-portal/chat-portal/chat-portal.component';
import { ReportsImsComponent } from './ui-portal/reports-ims/reports-ims.component';
import { ReceivePallentsComponent } from './ui-portal/receive-pallents/receive-pallents.component';
import { ContainersClientComponent } from './ui-portal/containers-client/containers-client.component';
import { InvoiceGenerateComponent } from './ui-portal/invoice-generate/invoice-generate.component';
import {  WarehouseNameLocationViewComponent } from './ui-portal/warehouse-name-location/warehouse-name-location.component';
import { LoginAppComponent } from './account/login-app/login-app.component';
import { EditInventoryComponent } from './ui-portal/edit-inventory/edit-inventory.component';

const routes: Routes = [
  { path: 'login', component: LoginUserComponent },
  { path: 'loginapp', component: LoginAppComponent },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin,Role.Customer,Role.werehouse],
    },
  },
  {
    path: 'shipping',
    component: ShippingComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'receive',
    component: ReceiveComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'receive-pallets',
    component: ReceivePallentsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'containers',
    component: ContainersComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'containers-client',
    component: ContainersClientComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.Customer, Role.Admin],
    },
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin,Role.Customer]
    },
  },
  {
    path: 'warehouse',
    component: WarehouseNameLocationViewComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'reports-ims',
    component: ReportsImsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'invoice',
    component: InvoiceGenerateComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'products',
    component: ProductsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'customers',
    component: CustomersComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  }, {
    path: 'admin',
    component: AdministradorComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'chat',
    component: ChatSignalRComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'chat-portal',
    component: ChatPortalComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin],
    },
  },
  {
    path: 'shiptorder',
    component: ShiptordersComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.Admin,Role.werehouse],
    },
  },
  {
    path: 'client',
    component: ClientComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.Customer,Role.Admin],
    },
  },
  {
    path: 'appareance',
    component: AppareanceComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.User, Role.Admin,Role.Customer,Role.werehouse],
    },
  },
  {
    path: 'inventory',
    component: EditInventoryComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [Role.Admin],
    },
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '/home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
